import { render } from "./ChooseToLocation.vue?vue&type=template&id=4d278a81"
import script from "./ChooseToLocation.vue?vue&type=script&lang=js"
export * from "./ChooseToLocation.vue?vue&type=script&lang=js"
script.render = render

export default script